import CONST from "./Constant";

const INITIAL_STATE = {
    list:[],
    failedList:[],
    error: [],
    code: "",
    config:{
        from:0,
        to:0,
        lastPage:1,
        total:0,
        pagination:{
            page:0,
            pageSize:10,
        },
        filters:{
            keyword:'',
            view:'all', // 'all', 'failed'
            sort_by:'id',
            sort_dir:'desc',
        }
    },
    dirty: false,
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.FETCH_JOBS_SUCCESS:
            return action.payload.config.params.paginate === undefined ? {
                ...state,
                list:action.payload.data.data,
                config:{
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Jobs loaded successfully"],
            } : {
                ...state,
                list: action.payload.data,
                error: [],
                code:action.payload.status,
                message: ["Jobs loaded successfully"],
            }
        case CONST.FETCH_FAILED_JOBS_SUCCESS:
            return action.payload.config.params.paginate === undefined ? {
                ...state,
                failedList:action.payload.data.data,
                config:{
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Failed jobs loaded successfully"],
            } : {
                ...state,
                failedList: action.payload.data,
                error: [],
                code:action.payload.status,
                message: ["Failed jobs loaded successfully"],
            }
        case CONST.MANUAL_RUN_SUCCESS:
            return {
                ...state,
                error: [],
                code:action.payload.status,
                message: ["Job dispatched successfully"],
                dirty: true,
            }
        case CONST.FETCH_JOBS_FAILED:
        case CONST.FETCH_FAILED_JOBS_FAILED:
        case CONST.MANUAL_RUN_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }
        default:
            return state;
    }
}

export default Reducer ;

